// The Foderis mark: the "Ledger F" (ADR-019). Same drawing as site/img/logo-mark.svg.
export function LogoMark({ size = 28, light = false }: { size?: number; light?: boolean }) {
  // On a green background the tile turns paper-coloured and the F green.
  return (
    <svg className="logo-mark" aria-hidden="true" width={size} height={size} viewBox="0 0 64 64">
      <rect width="64" height="64" rx="16" fill={light ? '#F5F3EE' : '#1F5F4A'} />
      <path
        d="M22 17h22M22 17v30M22 31h14"
        stroke={light ? '#1F5F4A' : '#F5F3EE'}
        strokeWidth="6.5"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="42" cy="45" r="4" fill={light ? '#1F5F4A' : '#9BD3B8'} />
    </svg>
  );
}

/** Wordmark with the mark, for headers. */
export function Brand({ light = false }: { light?: boolean }) {
  return (
    <span className="brand">
      <LogoMark light={light} />
      Foderis
    </span>
  );
}
